import { default as addAttemptConfiguration } from './attempts/add';
import { default as getAttemptsConfiguration } from './attempts/get';
import { default as saveAttemptConfiguration } from './attempts/save';
import { default as updateAttemptConfiguration } from './attempts/update';
import { default as submitAnswerConfiguration } from './questionAttempts/submitAnswer';
import { default as getQuestionConfiguration } from './questions/get';

export const questionConfigurations = [
  getQuestionConfiguration
]

export const attemptConfigurations = [
  getAttemptsConfiguration,
  addAttemptConfiguration,
  updateAttemptConfiguration,
  saveAttemptConfiguration
]

export const questionAttemptConfigurations = [
  submitAnswerConfiguration
]


// WEBPACK FOOTER //
// ./src/state/modules/quiz/configurations/index.js